import roundLabel, { roundsToFinal } from "../../roundLabel"

// A player still in a knockout draw is counted with the points of the round reached until their next result.
// The API already includes them in a verified `base`; an older API sends no `guaranteedMinimum`, so nothing is shown.
export const guaranteedMinimumText = component => {
  const minimum = component?.guaranteedMinimum
  if (component?.base == null || !Number.isSafeInteger(minimum?.points) || minimum.points < 1) return null
  const distance = roundsToFinal(minimum)
  return `Includes ${minimum.points} for ${distance === null ? "the round reached" : `reaching the ${roundLabel(distance)}`} · awaiting result`
}
